import SitemapApp from 'apps/Sitemap'
import messages from 'lang/es/sitemap'
import commonMessages from 'lang/es/common'
import { getCommonStaticProps } from 'commonPage'

export default SitemapApp

export const getStaticProps = async () => {
  const commonStaticProps = await getCommonStaticProps()
  return {
    props: {
      titleMeta: 'SITEMAP_TITLE',
      descriptionMeta: 'SITEMAP_DESCRIPTION',
      messages: {
        ...commonMessages,
        ...messages,
      },
      ...commonStaticProps,
      // allMakeModels,
    },
  }
}
